import React from "react";
import { Code } from "@singlestore/fusion/components/typography";
import { cx } from "class-variance-authority";

import "./KeyboardShortcut.scss";

type KeyboardShortcutProps = {
    className?: string;
};

export function KeyboardShortcut({
    children,
    className,
}: React.PropsWithChildren<KeyboardShortcutProps>) {
    const classes = cx("keyboard-shortcut", className);

    return (
        <Code variant="code-1" className={classes}>
            {children}
        </Code>
    );
}
